<template>
    <div id="banner-02">
        <article class="banner">
            <div class="text">{{$t('home2021.banners.footer.be_part')}}</div>
            <div class="banner-logo-webstars"></div>
            <div class="btn-action">
                <a
                    v-if="webstarsPanelUrl"
                    class="item"
                    :href="webstarsPanelUrl"
                >
                    {{$t('home2021.banners.footer.more_info')}}
                </a>
            </div>
        </article>
    </div>
</template>
<script>
export default {
    name: 'HomeBannerFooter',
    data(){
        return {
            webstarsPanelUrl: process.env.VUE_APP_WEBSTARS_PANEL_URL.replace(/\/+$/, "") + '/welcome'
        }
    },
}
</script>
<style scoped lang="scss">
@import '../../styles/variables';

section {
    text-align: left;
}

#banner-02{
    .banner{
        height: 330px;
        background-image: url(/img/2021/banner-04.jpg);
        background-position: center;
        background-repeat: no-repeat;
        position: relative;
        overflow: hidden;
        transition: filter 0.5s ease;
        border-top: 1px solid #C4022F;
        border-bottom: 1px solid #C4022F;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-transform: uppercase;
        &.loading {
            filter: blur(20px);
            background-color: $pallete_secondary_color;
        }
        @media(max-width: 960px){
            height: 250px;
            background-size: auto 250px;
        }

        .text{
            font-family: "Helvetica Narrow", Arial, Helvetica, sans-serif,sans-serif;
            transform: scale(1.2,  1.7);
            font-size: 2em;
            color: #ffffff;
            @media(max-width: 960px){
                transform: scale(1,  1);
            }
        }

        .banner-logo-webstars{
            width: 286px;
            height: 44px;
            background-position: center;
            background-repeat: no-repeat;
            background-image: url(/img/logo-white.png);
            background-size: contain;
            margin-top: 20px;
            margin-bottom: 20px;
            @media(max-width: 960px){
                margin-top: 5px;
                margin-bottom: 5px;
            }
        }

        .btn-action{
            width: 156px;
            line-height: 2.5;
            text-align: center;
            color: #ff0000;
            font-weight: bold;
            border: 3px solid #ff0000;
            border-radius: 10px;
            transition: 200ms;
            &:hover{
                background: #ff0000;
                color: #ffffff;
            }
            a{
                display: block;
                width: 100%;
                height: 100%;
            }
            @media(max-width: 960px){
            }
        }
    }
}
</style>
